import * as ActionTypes from './ActionTypes'
import { Map, List } from 'immutable'
import { CFD_SCREEN } from './Reducer'

// ON DEPRECATION NOTICE
const mockInitializationData = {
  base: {
    title: 'Please Configure Your POS',
    menuImage: undefined,
    image: undefined,
    color: '#000000',
    accessToken: undefined,
  },
}

const getInitialState = () => {
  return Map({
    cartItems: List([]), // a list of all the items in the cart
    screen: CFD_SCREEN.IDLE, // which screen section are they on, handles navigation between the screens, this way we can handle animations if need be
    transactionResult: Map({}), // The transaction result so we can display the receipt or error on the CFD
    cardError: Map({}), // What error the CFD Card Reader had so we can display it
    cartTotals: Map({}), // The totals for the current cart
    cartTotalsUuid: '', // The UUID of the cart totals for tracking purposes
    paymentData: Map({}),
    tips: Map({}), // contains details from POS to CFD about tips being enabled and tip suggestions
    orderUpdate: Map({}), // contains order details from CFD
    balanceToBePaid: Map({}),

    // NEW ARCHITECTURE
    currentCart: Map({}),
    currentOrder: Map({}),

    base: Map(mockInitializationData.base), // the base initialization data from POS
    androidConfig: {}, // the config containing the ESKey for transactions.
    debugger: '', // Temporary - The last message sent to the debugger
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNCFD_UPDATE_CART:
      return state.set('cartItems', List(action.cartItems))
    case ActionTypes.VNCFD_SET_SCREEN:
      return state.set('screen', action.screen)
    case ActionTypes.VNCFD_TRANSACTION_RESULT:
      return state.set('transactionResult', Map(action.data))
    case ActionTypes.VNCFD_CARD_ERROR:
      return state.set('cardError', Map(action.data))
    case ActionTypes.VNCFD_SET_CART_TOTALS:
      return state.set('cartTotals', Map(action.totals))
    case ActionTypes.VNCFD_PAYMENT_DATA:
      return state.set('paymentData', Map(action.data))
    case ActionTypes.VNCFD_TIPS_DATA:
      return state.set('tips', Map(action.tips))
    case ActionTypes.VN_ORDER_UPDATE:
      return state.set('orderUpdate', Map(action.data))
    case ActionTypes.VNCFD_BALANCE_TO_BE_PAID:
      return state.set('balanceToBePaid', Map(action.data))
    case ActionTypes.VNCFD_CURRENT_CART:
      return state.set('currentCart', Map(action.cart))
    case ActionTypes.VNCFD_SET_CURRENT_ORDER:
      return state.set('currentOrder', Map(action.order))

    // Original Persisted Reducer
    case ActionTypes.VNCFD_SET_CFD_INITIALIZED:
      return state.set('base', Map(action.data))
    case ActionTypes.VNCFD_SET_ANDROID_CONFIG:
      return state.set('androidConfig', action.data)
    case ActionTypes.VNCFD_DEBUGGER_DATA:
      return state.setIn('debugger', action.data)
    case ActionTypes.VNCFD_SET_CART_TOTALS_UUID:
      return state.set('cartTotalsUuid', action.uuid)
    // resets CFD state back to initial values
    case ActionTypes.VNCFD_RESET:
      const { resetOnlyPaymentsData, keepCartData } = action.data
      if (resetOnlyPaymentsData) {
        return state.set('transactionResult', Map({})).set('cartTotals', Map({})).set('paymentData', Map({}))
      }
      const updatedState = getInitialState().set('androidConfig', state.get('androidConfig')).set('base', state.get('base'))

      if (keepCartData) {
        return updatedState.set('cartItems', state.get('cartItems'))
      }

      return updatedState

    default:
      return state
  }
}

export default reducer
